var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAustralia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_5656)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_5656",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_5656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 3H3V23H33V3Z",
    fill: "#2C2A7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8926 15.2465L11.3496 16.8735L12.7441 16.2709L11.918 17.6904L13.2012 18.5541L11.7129 18.7081L11.918 20.3954L10.8926 19.1567L9.86719 20.3954L10.0723 18.7081L8.58398 18.5541L9.86719 17.6904L9.04102 16.2709L10.4355 16.8735L10.8926 15.2465Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6777 18.1724L26.8945 18.9424L27.5566 18.6545L27.1641 19.3307L27.7793 19.7458L27.0703 19.8128L27.1641 20.6163L26.6777 20.0271L26.1855 20.6163L26.2852 19.8128L25.5762 19.7458L26.1914 19.3307L25.793 18.6545L26.4609 18.9424L26.6777 18.1724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7285 11.0281L22.9511 11.8048L23.6133 11.5169L23.2207 12.1931L23.83 12.6016L23.1211 12.6752L23.2207 13.4787L22.7285 12.8895L22.2422 13.4787L22.3418 12.6752L21.6328 12.6016L22.2422 12.1931L21.8496 11.5169L22.5117 11.8048L22.7285 11.0281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6777 6.14697L26.8945 6.91698L27.5566 6.62906L27.1641 7.30533L27.7793 7.72046L27.0703 7.79411L27.1641 8.59759L26.6777 8.00837L26.1855 8.59759L26.2852 7.79411L25.5762 7.72046L26.1914 7.30533L25.793 6.62906L26.4609 6.91698L26.6777 6.14697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1875 9.82959L30.4043 10.5996L31.0664 10.3117L30.6739 10.9879L31.2832 11.4031L30.5742 11.4767L30.6739 12.2802L30.1875 11.691L29.6953 12.2802L29.795 11.4767L29.086 11.4031L29.6953 10.9879L29.3028 10.3117L29.9649 10.5996L30.1875 9.82959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2539 13.4453L28.4297 13.9274L28.8809 13.9676L28.5352 14.3024L28.6407 14.8045L28.2539 14.53L27.8672 14.8045L27.9785 14.3024L27.6328 13.9676L28.084 13.9274L28.2539 13.4453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.57422 3V6.00636H3V9.01272H9.57422V12.0191H12.2051V9.01272H18.7852V6.00636H12.2051V3H9.57422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3V4.00435L17.0215 12.0191H18.7852V11.008L4.76367 3H3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0215 3L3 11.008V12.0191H4.76367L18.7852 4.00435V3H17.0215Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1016 3V6.60228H3V8.41011H10.1016V12.0191H11.6836V8.41011H18.7852V6.60228H11.6836V3H10.1016Z",
    fill: "#E91E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 3V3.66957L7.08398 5.99967H8.26172L3 3ZM17.6074 3L12.3457 6.00636H13.5234L18.7852 3H17.6074Z",
    fill: "#E91E26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.26172 9.01273L3 12.0191H4.17773L9.43945 9.01273H8.26172ZM13.5234 9.01273L18.7852 12.0191V11.3495L14.7012 9.01273H13.5234Z",
    fill: "#E91E26"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_5656",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_5656"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_5656",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAustralia);
export default __webpack_public_path__ + "static/media/Australia.ef5761c1fc78af74ea97bb9552e65399.svg";
export { ForwardRef as ReactComponent };